<template>
  <div>
    <div>
      <div class="left">
        <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-form-model-item label="Title / Tên phòng ban" prop="name">
              <a-input v-model="form.name" placeholder="Nhập tên phòng ban" />
            </a-form-model-item>
            <a-form-model-item
              label="Belong to department / Thuộc phòng ban"
              prop="parentId"
            >
              <SelectDepartment
                v-model="form.parentId"
                :initialDatas="form.parent ? [form.parent] : []"
                :selectProps="{
                  value: form.parentId,
                  placeholder: 'Department',
                }"
              />
            </a-form-model-item>

            <a-form-model-item
              label="Manager / Người quản lý"
              prop="managerIds"
            >
              <SelectUser
                v-model="form.managerIds"
                :initialDatas="form.managers"
                :selectProps="{
                  value: form.managerIds,
                  placeholder: 'Select account',
                  mode: 'multiple',
                }"
                :variablesQuery="{
                  hasEmployee: undefined,
                }"
              />
            </a-form-model-item>

            <a-form-model-item
              label="Permission View Report / Quyền xem báo cáo"
            >
              <SelectUser
                v-model="form.hrReporterIds"
                :initialDatas="form.hrReporters"
                :selectProps="{
                  value: form.hrReporterIds,
                  placeholder: 'Select account',
                  mode: 'multiple',
                }"
                :variablesQuery="{
                  hasEmployee: undefined,
                }"
              />
            </a-form-model-item>

            <a-form-model-item label="Helper / Người tạo hộ" prop="managerIds">
              <SelectUser
                v-model="form.createHelperIds"
                :initialDatas="form.createHelpers || []"
                :selectProps="{
                  value: form.createHelperIds,
                  placeholder: 'Select users',
                  mode: 'multiple',
                }"
                :variablesQuery="{
                  hasEmployee: undefined,
                }"
              />
            </a-form-model-item>

            <a-form-model-item
              label="Supervisors / Trưởng nhóm"
              prop="supervisorIds"
            >
              <SelectUser
                v-model="form.supervisorIds"
                :initialDatas="form.supervisors || []"
                :selectProps="{
                  value: form.supervisorIds,
                  placeholder: 'Select users',
                  mode: 'multiple',
                }"
                :variablesQuery="{
                  hasEmployee: undefined,
                  departmentIds: [form.id],
                }"
              />
            </a-form-model-item>

            <a-form-model-item label="Shift / Ca làm việc" prop="managerIds">
              <SelectWorkShift
                v-model="form.workShiftIds"
                :initialDatas="[...form.workShifts]"
                :selectProps="{
                  value: form.workShiftIds,
                  placeholder: 'Select shifts',
                  mode: 'multiple',
                }"
              />
            </a-form-model-item>

            <a-form-model-item has-feedback label="Active" prop="status">
              <a-switch
                @change="onChangeDepartment"
                :defaultChecked="checkDepartment"
                size="default"
              />
            </a-form-model-item>
            <a-form-model-item has-feedback label="Document">
              <a-checkbox v-model="form.canShowOnDocument">
                Show on document
              </a-checkbox>
            </a-form-model-item>
          </a-form-model>
        </a-skeleton>
      </div>

      <div class="right">
        <a-divider orientation="left">
          SHIFT
        </a-divider>
        <a-table
          :loading="loading"
          :pagination="false"
          :columns="columnsAllWorkShift"
          :data-source="form.workShifts"
          size="small"
          rowKey="id"
        >
          <div slot="stt" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>

          <span slot="isOvertime" slot-scope="text">
            <p v-if="text">
              <a-icon type="check" style="margin-left: 5px; color: #52c419;" />
            </p>
          </span>
          <span slot="startTime" slot-scope="text">
            {{ text | formatTime }}
          </span>
          <span slot="endTime" slot-scope="text">
            {{ text | formatTime }}
          </span>
        </a-table>

        <a-divider orientation="left">
          MANAGER
        </a-divider>

        <a-table
          :loading="loading"
          :pagination="false"
          :columns="columnsManagers"
          :data-source="form.managers"
          size="small"
          rowKey="id"
        >
          <div slot="stt" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
        </a-table>

        <a-divider orientation="left">
          PERMISSION VIEW REPORT
        </a-divider>

        <a-table
          :loading="loading"
          :pagination="false"
          :columns="columnsManagers"
          :data-source="form.hrReporters"
          size="small"
          rowKey="id"
        >
          <div slot="stt" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
        </a-table>

        <a-divider orientation="left">
          EMPLOYEE
        </a-divider>

        <a-table
          :loading="loadingEmployee"
          :columns="columnsManagers"
          :data-source="employees"
          size="small"
          rowKey="id"
        >
          <div slot="title">
            <a-input
              placeholder="Search..."
              @change="onFilterEmployee"
              v-model="queryEmployee"
            ></a-input>
          </div>
          <div slot="stt" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
        </a-table>

        <div>
          <a-divider orientation="left">
            Information
          </a-divider>

          <a-descriptions :column="1">
            <a-descriptions-item label="Created by">
              {{
                form.author && (form.author.fullname || form.author.username)
              }}
            </a-descriptions-item>
            <a-descriptions-item label="Created at">
              {{ form.createdAt | formatDateHour }}
            </a-descriptions-item>
            <a-descriptions-item label="Updated at">
              {{ form.updatedAt | formatDateHour }}
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>

      <div
        v-if="!loading"
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action ?"
          ok-text="Delete"
          cancel-text="Close"
          @confirm="deleteDepartment"
        >
          <a-button
            type="danger"
            icon="delete"
            style="margin-right: 5px; float: left;"
            :loading="loadingDelete"
          >
            Delete
          </a-button>
        </a-popconfirm>
        <a-button
          @click="closeDrawerUpdateDepartment"
          icon="close"
          style="margin-right: 5px;"
        >
          Close
        </a-button>
        <a-button
          type="primary"
          icon="edit"
          @click="updateDepartment"
          :loading="loadingUpdate"
        >
          Update
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import getQuery from "../../data/getData";
import postQuery from "../../data/postData";
import SelectDepartment from "@/components/common/department/select";
import SelectUser from "@/components/common/user/select";
import { columnsAllWorkShift } from "../../Constants/dataColumns";
import { columnsManagers } from "../../Constants/dataColumns";
import SelectWorkShift from "@/components/common/workShift/select";
import debounce from "lodash/debounce";

export default {
  components: { SelectDepartment, SelectUser, SelectWorkShift },
  props: {
    updateDepartmentOnView: {
      type: Function,
      default: null,
    },
    deleteDepartmentOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdateDepartment: {
      type: Function,
      default: null,
    },
    idDepartment: {
      type: String,
      default: null,
    },
  },
  data() {
    this.onFilterEmployee = debounce(this.onFilterEmployee, 500);
    return {
      columnsAllWorkShift,
      columnsManagers,
      checkDepartment: true,
      loadingUpdate: false,
      loadingDelete: false,
      loadingEmployee: false,
      loading: true,
      employees: [],
      form: {
        name: null,
        status: null,
        managerIds: [],
        supervisorIds: [],
        parentId: undefined,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Required / Tên phòng ban không được bỏ trống",
            trigger: "change",
          },
        ],
      },
      queryEmployee: "",
    };
  },
  methods: {
    onChangeDepartment(checked) {
      if (checked) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },

    getDepartment() {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetDepartment,
          fetchPolicy: "no-cache",
          variables: {
            id: this.idDepartment,
          },
        })
        .then(({ data }) => {
          if (data?.getDepartment) {
            this.form = {
              ...data.getDepartment,
              parentId: data.getDepartment?.parentId || undefined,
              workShiftIds: data.getDepartment?.workShifts
                ? data.getDepartment.workShifts.map((e) => e.id)
                : undefined,
              createHelperIds: data.getDepartment?.createHelpers
                ? data.getDepartment.createHelpers.map((e) => e.id)
                : undefined,
              supervisorIds: data.getDepartment?.supervisors
                ? data.getDepartment.supervisors.map((e) => e.id)
                : undefined,
              hrReporterIds: data.getDepartment?.hrReporters
                ? data.getDepartment.hrReporters.map((e) => e.id)
                : undefined,
            };
            if (this.form.managers?.length === 0) {
              this.$set(this.form, "managerIds", []);
            } else {
              const listUser = this.form.managers?.map((item) => item.id);
              this.$set(this.form, "managerIds", listUser);
            }

            if (this.form.status === "ACTIVE") {
              this.checkDepartment = true;
            } else {
              this.checkDepartment = false;
            }

            // getEmployee in deparments
            this.onGetEmployeeInDepartments(data.getDepartment.id);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          this.loading = false;
          console.log("Không lấy được chi tiết phòng ban", error);
        });
    },
    onGetEmployeeInDepartments(idDepartment) {
      this.loadingEmployee = true;
      this.$apollo
        .query({
          query: getQuery.getAllEmployee,
          fetchPolicy: "no-cache",
          variables: {
            query: this.queryEmployee,
            departmentIds: idDepartment,
          },
        })
        .then(({ data }) => {
          if (data?.getAllEmployee) {
            this.employees = [...data.getAllEmployee];
          }
          this.loadingEmployee = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          this.loadingEmployee = false;
          console.log("Không lấy được chi tiết phòng ban", error);
        });
    },
    onFilterEmployee() {
      this.onGetEmployeeInDepartments(this.idDepartment);
    },
    updateDepartment() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          console.log("parentId", this.form.parentId);
          this.$apollo
            .mutate({
              mutation: postQuery.queryUpdateDepartment,
              variables: {
                ...this.form,
                name: this.form.name,
                status: this.form.status,
                id: this.idDepartment,
                parentId: this.form.parentId || null,
                managerIds: this.form.managerIds,
                workShiftIds: this.form.workShiftIds,
                createHelperIds: this.form.createHelperIds,
                hrReporterIds: this.form.hrReporterIds,
                supervisorIds: this.form.supervisorIds,
              },
            })
            .then(({ data }) => {
              if (data?.updateDepartment) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });

                this.closeDrawerUpdateDepartment();
                this.updateDepartmentOnView(data.updateDepartment);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              console.log("Không cập nhật được phòng ban", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
    deleteDepartment() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeleteDepartment,
          variables: {
            id: this.idDepartment,
          },
        })
        .then(({ data }) => {
          if (data?.deleteDepartment) {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });
            this.closeDrawerUpdateDepartment();
            this.deleteDepartmentOnView(data.deleteDepartment);
          }

          this.loadingDelete = false;
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.$notification.error({
            message: "Error",
            description: "Deleted Error!",
          });
          console.log("Xóa phòng ban không thành công", error);
        });
    },
  },

  created() {
    this.getDepartment();
  },
};
</script>
<style></style>
